import { render, staticRenderFns } from "./BusinessDescription.vue?vue&type=template&id=79590250&scoped=true&"
import script from "./BusinessDescription.vue?vue&type=script&lang=ts&"
export * from "./BusinessDescription.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessDescription.vue?vue&type=style&index=0&id=79590250&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79590250",
  null
  
)

export default component.exports